import { post } from "@/plugin/newAxios";
//办理限制-外服老挝段车站办理限制查询
export const queryblxzByCzApi = params => post('/zhfw/v1/blxz/queryblxzByCz', params)
//办理限制-中国段车站办理限制查询
export const queryCnblxzByCzApi = params => post('/zhfw/v1/blxz/queryCnblxzByCz', params)
//办理限制-出口集装箱效验-老挝段
export const xyckjzxloApi = params => post('/zhfw/v1/blxz/xyckjzxlo', params)
//办理限制-中国段车站 办理限制查询
export const xyckjzxcnApi = params => post('/zhfw/v1/blxz/xyckjzxcn', params)
//办理限制-进口集装箱效验-老挝段-内外服都调用
export const xyjkjzxloApi = params => post('/zhfw/v1/blxz/xyjkjzxlo', params)
//办理限制效验-出口整车-中国段
export const xyckzccnApi = params => post('/zhfw/v1/blxz/xyckzccn', params)
// //办理限制效验-出口整车-老挝段
export const xyckzcloApi = params => post('/zhfw/v1/blxz/xyckzclo', params)

// //办理限制效验-超重超限
// export const xyjkjzxloApi = params => post('/zhfw/v1/blxz/xyckzclo', params)
